import { useEffect, useState } from "react";
import { getPedidosPendientesDireccion } from "../services/pedidosService";

// Dirección elegida, cliente asociado, aviso de pedido pendiente y detección
// de coordenadas faltantes. "tabla" se recibe porque el original re-evalúa
// las coordenadas al volver de los sub-modales.
export const useSeleccionDireccion = ({ tabla }) => {
  const [direccionSeleccionada, setdireccionSeleccionada] = useState("");
  const [clienteSeleccionado, setClienteSeleccionado] = useState("");
  const [pedidoPendDirec, setPedidoPendDirec] = useState();
  const [agregarCoordenadas, setAgregarCoordenadas] = useState(false);

  const handleDireccionSeleccionada = (newValue) => {
    if (!newValue) {
      setdireccionSeleccionada("");
      setClienteSeleccionado("");
      return;
    }

    setdireccionSeleccionada(newValue);

    if (newValue.id_cliente) {
      setClienteSeleccionado({
        id: newValue.id_cliente,
        razon_social: newValue.razon_social,
        sisven_id: newValue.sisven_id,
        sucursal: newValue.cliente_sucursal || newValue.sucursal,
      });
    }
  };

  const limpiarSeleccion = () => {
    setdireccionSeleccionada("");
    setClienteSeleccionado("");
  };

  useEffect(() => {
    if (direccionSeleccionada && direccionSeleccionada.id) {
      getPedidosPendientesDireccion(direccionSeleccionada.id).then(setPedidoPendDirec);
    }
  }, [direccionSeleccionada]);

  useEffect(() => {
    if (
      direccionSeleccionada &&
      (direccionSeleccionada.latitud === null ||
        direccionSeleccionada.longitud === null)
    ) {
      setAgregarCoordenadas(true);
    } else {
      setAgregarCoordenadas(false);
    }
  }, [direccionSeleccionada, tabla]);

  return {
    direccionSeleccionada,
    clienteSeleccionado,
    pedidoPendDirec,
    agregarCoordenadas,
    handleDireccionSeleccionada,
    limpiarSeleccion,
  };
};
